import React from 'react'
import { observer } from 'mobx-react-lite'
import Modal from '../../../../../Modal/Modal'

export default observer(function DeleteProjectAssetModal({
  isOpen,
  onClose,
  assetName,
  onConfirm,
  isDeleting = false,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>Delete project asset</Modal.Header>
      <Modal.Body>
        <div className="w-[400px]">
          <p className="mb-3 font-bold dark:text-white">
            Are you sure you want to delete &quot;{assetName}&quot;?
          </p>
          <p className="text-sm text-rb-lighter-grey dark:text-gray-400">
            This action cannot be undone.
          </p>

          <div className="flex justify-between mt-5">
            <button
              type="button"
              className="rb-btn-cancel font-bold text-md p-2 px-4 rounded-lg"
              onClick={onClose}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="ml-auto bg-red-500 text-white rounded-lg p-2 px-4 submit text-center disabled:opacity-60"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
